'use strict';


var providers = {};


module.exports = {
    onAppInit: function ( pluginConfig, callback ) {
        var collector = require('./lib/collector'),
            api = require('../../index');

        collector.imagePath = pluginConfig.path + 'img/' + screen.height + '/';

        collector.destroy = function () {
            // needs to clearify in launcher for develop mode
            providers = {};
            collector.rows = [];
            collector.providers = [];
        };

        require('mag-gettext').load({name: core.environment.language}, function () {
            var gettext = require('mag-gettext').gettext;

            console.log('PACKAGE_MAJOR_VERSION is ' + PACKAGE_MAJOR_VERSION);

            collector.providers.push({
                application: {
                    name: gettext('Apps'),
                    colors: {
                        splashFont: '#fff',
                        splashBackground: '#efbe01'
                    },
                    uris: {
                        icons: {
                            primeLogoActive: collector.imagePath   + 'apps.icon.focus.png',
                            primeLogoNormal: collector.imagePath   + 'apps.icon.png',
                            shadowNormal: collector.imagePath + 'apps.shadow.png',
                            shadowActive: collector.imagePath + 'apps.shadow.focus.png'
                        }
                    }
                },
                layout: 'apps'
            });
            collector.rows.push([]);

            // filling the list of content providers and applications
            core.packages.forEach(function ( packageData ) {
                var layout = false,
                    // addRow = null,
                    providerConfig;

                if ( packageData.type === 'app' ) {
                    // add to application list
                    // console.log('add to applications ' + packageData.name);

                    console.log(packageData.packageName);
                    collector.rows[0].push({
                        layout: api.layouts.application,
                        geometry: api.geometry.horizontal,
                        data: {
                            name: packageData.name,
                            description: packageData.description,
                            colors: packageData.colors,
                            icons: packageData.uris.icons,
                            onClick: function () {
                                require('./utils/run.app')(packageData);
                            }
                        }
                    });

                    // resolve content providers
                    if ( packageData.contentProviders && packageData.contentProviders.length > 0 ) {
                        console.log('check for providers in applications ' + packageData.name);
                        // create
                        if ( typeof packageData.contentProviders === 'string' ) {
                            console.log('packageData.contentProviders: ' + packageData.contentProviders);
                            providerConfig = window.core.packageMap[packageData.contentProviders];
                            if ( typeof providerConfig === 'undefined' ) {
                                return;
                            }

                            if ( providerConfig.contentBoardApi === PACKAGE_MAJOR_VERSION ) {
                                // more then one application
                                if ( providers[providerConfig.packageName] ) {
                                    console.log('pkg ' + providerConfig.packageName);
                                    providers[providerConfig.packageName].applications.push(packageData);

                                    return;
                                }
                                // console.log('PUSH TO PROVIDERS');
                                // console.log(providerConfig.packageName);

                                if ( packageData.resource ) {
                                    layout = packageData.resource;
                                }
                                console.log('layout: ' + layout);

                                providers[providerConfig.packageName] = {
                                    colors: packageData.colors,
                                    instance: null,
                                    packageName: providerConfig.packageName,
                                    version: providerConfig.version,
                                    application: packageData,
                                    applications: [packageData],
                                    layout: layout,
                                    onClick: function () {
                                        require('./utils/run.app')(packageData);
                                    }
                                };
                                collector.providers.push(providers[providerConfig.packageName]);
                            }
                        } else {
                            console.log('providers is array');
                            packageData.contentProviders.forEach(function ( provider ) {
                                console.log('packageData.contentProviders: ' + provider);
                                providerConfig = core.packageMap[provider];
                                if ( typeof providerConfig === 'undefined' ) {
                                    return;
                                }

                                // console.log(provider);
                                // console.log('contentBoardAPI ' + JSON.stringify(providerConfig.contentBoardApi));
                                // console.log('PACKAGE_MAJOR_VERSION ' + JSON.stringify(PACKAGE_MAJOR_VERSION));
                                if ( providerConfig.contentBoardApi === PACKAGE_MAJOR_VERSION ) {
                                    if ( providers[providerConfig.packageName] ) {
                                        providers[providerConfig.packageName].applications.push(packageData);

                                        return;
                                    }

                                    // console.log('PUSH to providers');
                                    // console.log(providerConfig.packageName);

                                    if ( packageData.resource ) {
                                        layout = packageData.resource;
                                    }

                                    providers[providerConfig.packageName] = {
                                        colors: packageData.colors,
                                        instance: null,
                                        packageName: provider,
                                        version: providerConfig.version,
                                        application: packageData,
                                        applications: [packageData],
                                        layout: layout,
                                        onClick: function () {
                                            require('./utils/run.app')(packageData);
                                        }
                                    };
                                    collector.providers.push(providers[providerConfig.packageName]);
                                }
                            });
                        }
                    }
                }
            });

            // console.log('providers.length at start ' + collector.providers.length);

            if ( DEVELOP ) {
                try {
                    callback(null, collector);
                } catch ( error ) {
                    console.log('error in plugin ' + __filename + ':112 ' + error);
                }
            } else {
                callback(null, collector);
            }
        });
    }
};
